import { render, staticRenderFns } from "./Secadero.vue?vue&type=template&id=1e362878&scoped=true&lang=es"
import script from "./Secadero.vue?vue&type=script&lang=js"
export * from "./Secadero.vue?vue&type=script&lang=js"
import style0 from "./Secadero.vue?vue&type=style&index=0&id=1e362878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e362878",
  null
  
)

export default component.exports